import React, {useEffect, useState} from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import Fade from '@material-ui/core/Fade';
import Slide from '@material-ui/core/Slide';
import {makeStyles} from '@material-ui/core/styles';
import AuthService from "../../services/auth.service";
import TextInput from "../form/input/TextInput";
import {NotificationManager} from "react-notifications";
import Cloud from '../../assets/cloud.jpg'
import {Link} from "react-router-dom";

const BRAND_DEEP = '#2c4767';
const BRAND_DEEP_DARK = '#1e3553';
const BRAND_GOLD = '#b08d57';
const BRAND_GOLD_SOFT = 'rgba(176, 141, 87, 0.18)';
const CREAM = '#f7f4ee';
const INK = '#1a2733';
const INK_SOFT = '#5a6675';

function Copyright({className}) {
    return (
        <Typography variant="body2" align="center" component={"div"} className={className}>
            {'Copyright © Moderné pohrebníctvo '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100vh',
        background: CREAM,
        [theme.breakpoints.up('md')]: {
            flexDirection: 'row-reverse',
            height: '100vh',
        },
    },
    hero: {
        position: 'relative',
        backgroundImage: `linear-gradient(135deg, rgba(30, 53, 83, 0.72) 0%, rgba(44, 71, 103, 0.55) 55%, rgba(44, 71, 103, 0.35) 100%), url(${Cloud})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        color: '#ffffff',
        [theme.breakpoints.up('md')]: {
            minHeight: '100vh',
        },
    },
    heroInner: {
        padding: theme.spacing(8, 6),
        maxWidth: 640,
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: '100%',
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(6, 3, 7, 3),
        },
    },
    heroEyebrow: {
        textTransform: 'uppercase',
        letterSpacing: 4,
        fontSize: 12,
        fontWeight: 600,
        opacity: 0.9,
        marginBottom: theme.spacing(2),
        color: '#e8d9b8',
    },
    heroTitle: {
        fontWeight: 700,
        lineHeight: 1.15,
        fontSize: '2.25rem',
        letterSpacing: '-0.5px',
        [theme.breakpoints.up('md')]: {
            fontSize: '2.6rem',
        },
    },
    heroDivider: {
        width: 56,
        height: 3,
        background: BRAND_GOLD,
        borderRadius: 2,
        margin: theme.spacing(3, 0),
    },
    heroBody: {
        fontSize: '1.05rem',
        lineHeight: 1.75,
        opacity: 0.94,
        '& a': {
            color: '#f0d9a8',
            textDecoration: 'underline',
            textUnderlineOffset: 3,
            fontWeight: 600,
        },
    },
    heroContactBlock: {
        marginTop: theme.spacing(6),
        padding: theme.spacing(3, 3.5),
        borderRadius: 12,
        background: 'rgba(255, 255, 255, 0.08)',
        backdropFilter: 'blur(6px)',
        border: '1px solid rgba(255, 255, 255, 0.12)',
    },
    heroContactTitle: {
        fontWeight: 700,
        fontSize: '1.25rem',
        marginBottom: theme.spacing(1.5),
    },
    heroContactBody: {
        fontSize: '1rem',
        lineHeight: 1.85,
    },
    contactStrong: {
        fontWeight: 700,
        color: '#f0d9a8',
    },
    formPanel: {
        background: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(6, 3),
        [theme.breakpoints.up('md')]: {
            padding: theme.spacing(8, 6),
        },
    },
    formInner: {
        width: '100%',
        maxWidth: 420,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    brandRow: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: theme.spacing(3),
    },
    brandName: {
        marginTop: theme.spacing(2),
        fontWeight: 700,
        fontSize: '0.95rem',
        letterSpacing: 3,
        textTransform: 'uppercase',
        color: BRAND_DEEP,
    },
    brandSubtitle: {
        color: INK_SOFT,
        fontSize: '0.78rem',
        letterSpacing: 1.5,
        textTransform: 'uppercase',
        marginTop: 2,
    },
    avatar: {
        width: 64,
        height: 64,
        background: `linear-gradient(135deg, ${BRAND_DEEP} 0%, ${BRAND_DEEP_DARK} 100%)`,
        boxShadow: `0 8px 24px ${BRAND_GOLD_SOFT}`,
        border: `2px solid ${BRAND_GOLD}`,
    },
    avatarIcon: {
        color: '#ffffff',
        fontSize: 28,
    },
    formHeading: {
        marginTop: theme.spacing(2),
        fontWeight: 700,
        fontSize: '1.75rem',
        color: INK,
    },
    formHint: {
        color: INK_SOFT,
        marginTop: theme.spacing(0.5),
        fontSize: '0.95rem',
    },
    form: {
        width: '100%',
        marginTop: theme.spacing(4),
    },
    inputRow: {
        marginBottom: theme.spacing(2.5),
    },
    input: {
        '& .MuiOutlinedInput-root': {
            borderRadius: 10,
            background: '#fbfaf7',
            fontSize: '1.05rem',
            '& fieldset': {
                borderColor: 'rgba(44, 71, 103, 0.18)',
            },
            '&:hover fieldset': {
                borderColor: BRAND_GOLD,
            },
            '&.Mui-focused fieldset': {
                borderColor: BRAND_DEEP,
                borderWidth: 2,
            },
        },
        '& .MuiOutlinedInput-input': {
            padding: '16px 14px',
        },
        '& .MuiInputLabel-root': {
            color: INK_SOFT,
            fontWeight: 500,
        },
        '& .MuiInputLabel-root.Mui-focused': {
            color: BRAND_DEEP,
        },
    },
    submit: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(1.75, 2),
        background: `linear-gradient(135deg, ${BRAND_DEEP} 0%, ${BRAND_DEEP_DARK} 100%)`,
        color: '#ffffff',
        fontWeight: 600,
        fontSize: '1.05rem',
        letterSpacing: 0.5,
        textTransform: 'none',
        borderRadius: 10,
        boxShadow: '0 6px 18px rgba(44, 71, 103, 0.25)',
        transition: 'transform 120ms ease, box-shadow 200ms ease',
        '&:hover': {
            background: `linear-gradient(135deg, ${BRAND_DEEP_DARK} 0%, ${BRAND_DEEP} 100%)`,
            boxShadow: '0 10px 26px rgba(44, 71, 103, 0.35)',
            transform: 'translateY(-1px)',
        },
        '&:active': {
            transform: 'translateY(0)',
        },
    },
    copyright: {
        marginTop: theme.spacing(5),
        color: INK_SOFT,
        fontSize: '0.85rem',
    },
    loggedInWrap: {
        background: CREAM,
        minHeight: '100vh',
    },
    loggedInHero: {
        position: 'relative',
        backgroundImage: `linear-gradient(135deg, rgba(30, 53, 83, 0.7) 0%, rgba(44, 71, 103, 0.45) 100%), url(${Cloud})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        color: '#ffffff',
        padding: theme.spacing(10, 3, 8, 3),
        [theme.breakpoints.up('md')]: {
            padding: theme.spacing(14, 6, 10, 6),
        },
    },
    loggedInHeroInner: {
        maxWidth: 880,
        margin: '0 auto',
    },
    loggedInContact: {
        maxWidth: 880,
        margin: '-48px auto 64px auto',
        padding: theme.spacing(4, 4),
        background: '#ffffff',
        borderRadius: 14,
        boxShadow: '0 10px 40px rgba(44, 71, 103, 0.12)',
        border: `1px solid ${BRAND_GOLD_SOFT}`,
        position: 'relative',
        zIndex: 2,
        [theme.breakpoints.down('sm')]: {
            margin: theme.spacing(3, 2, 6, 2),
            padding: theme.spacing(3),
        },
    },
    loggedInContactTitle: {
        fontWeight: 700,
        color: BRAND_DEEP,
        marginBottom: theme.spacing(2),
        fontSize: '1.6rem',
    },
    loggedInContactBody: {
        color: INK,
        fontSize: '1.05rem',
        lineHeight: 1.85,
        '& strong': {
            color: BRAND_DEEP,
        },
    },
}));

export default function SignInSide(props) {
    const classes = useStyles();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const user = AuthService.getCurrentUser();

    const onChangeUsername = (e) => {
        const username = e.target.value;
        setUsername(username);
    };

    const onChangePassword = (e) => {
        const password = e.target.value;
        setPassword(password);
    };

    const handleLogin = (e) => {
        e.preventDefault();

        AuthService.login(username, password).then(
            () => {
                props.history.push("/");
                window.location.reload();
            },
            () => {
                setPassword('');
                NotificationManager.error('Nesprávne údaje!', 'Chyba', 5000);
            }
        );
    };

    useEffect(() => {
    }, []);

    if (user) {
        return (
            <div className={classes.loggedInWrap}>
                <CssBaseline/>
                <Fade in timeout={600}>
                    <div className={classes.loggedInHero}>
                        <div className={classes.loggedInHeroInner}>
                            <Typography className={classes.heroEyebrow}>Moderné pohrebníctvo</Typography>
                            <Typography variant="h4" component="h1" className={classes.heroTitle}>
                                Vitajte na stránke MODERNÉ
                                POHREBNÍCTVO, prvá aplikácia pre
                                pohrebné služby
                            </Typography>
                            <div className={classes.heroDivider}/>
                            <Typography className={classes.heroBody} component="div">
                                MODERNÉ POHREBNÍCTVO je webová aplikácia, ktorá pomáha modernizovať
                                pohrebné služby. Táto webová aplikácia slúži pohrebníctvam na kompletne
                                zaznamenanie a vybavenie pohrebu.
                                Tak ako každé odvetvie prechádza modernizáciou, rozhodli
                                sme sa s našou firmou MODERNÉ POHREBNÍCTVO priniesť túto modernizáciu
                                aj do sveta pohrebných služieb. Sme jediní na Slovensku, kto takúto aplikáciu ponúka.
                                Preto nás neváhajte kontaktovať a zmodernizujte aj Vy Vaše pohrebníctvo.
                                Chcete vedieť <Link to="/informacie" target="_blank" rel="noopener noreferrer">viac</Link>?
                            </Typography>
                        </div>
                    </div>
                </Fade>
                <Slide in direction="up" timeout={500}>
                    <div className={classes.loggedInContact}>
                        <Typography className={classes.loggedInContactTitle} component="h2">
                            Kontakt
                        </Typography>
                        <Typography className={classes.loggedInContactBody} component="div">
                            V prípade záujmu alebo akýchkoľvek otázok nás neváhajte kontaktovať: Marek Kandráč
                            - <strong>0907292958</strong>
                            <br/>
                            Mailovou formou na: <strong>modernepohrebnictvo@gmail.com</strong>
                        </Typography>
                    </div>
                </Slide>
            </div>
        );
    }

    return (
        <Grid container component="div" className={classes.root}>
            <CssBaseline/>

            <Grid item xs={12} md={5} component={Paper} elevation={0} square className={classes.formPanel}>
                <Fade in timeout={500}>
                    <div className={classes.formInner}>
                        <div className={classes.brandRow}>
                            <Avatar className={classes.avatar}>
                                <LockOutlinedIcon className={classes.avatarIcon}/>
                            </Avatar>
                            <Typography className={classes.brandName}>Moderné pohrebníctvo</Typography>
                            <Typography className={classes.brandSubtitle}>Pohrebná aplikácia</Typography>
                        </div>

                        <Typography component="h1" className={classes.formHeading}>
                            Prihláste sa
                        </Typography>
                        <Typography className={classes.formHint}>
                            Zadajte prosím Vaše prihlasovacie údaje.
                        </Typography>

                        <form className={classes.form} onSubmit={handleLogin} noValidate>
                            <div className={classes.inputRow}>
                                <TextInput
                                    className={classes.input}
                                    label="Prihlasovacie meno"
                                    name={'username'}
                                    id="username"
                                    value={username}
                                    onChange={onChangeUsername}
                                    autoComplete="username"
                                    autoFocus
                                    fullWidth
                                    required
                                />
                            </div>
                            <div className={classes.inputRow}>
                                <TextInput
                                    className={classes.input}
                                    label="Heslo"
                                    type="password"
                                    name={'password'}
                                    value={password}
                                    autoComplete="current-password"
                                    fullWidth
                                    required
                                    onChange={onChangePassword}
                                />
                            </div>
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                className={classes.submit}
                                disableElevation
                            >
                                Prihlásiť sa
                            </Button>
                        </form>
                        <Copyright className={classes.copyright}/>
                    </div>
                </Fade>
            </Grid>

            <Grid item xs={12} md={7} className={classes.hero}>
                <Fade in timeout={700}>
                    <div className={classes.heroInner}>
                        <Typography className={classes.heroEyebrow}>Moderné pohrebníctvo</Typography>
                        <Typography variant="h4" component="h2" className={classes.heroTitle}>
                            Vitajte na stránke MODERNÉ
                            POHREBNÍCTVO, prvá aplikácia pre
                            pohrebné služby
                        </Typography>
                        <div className={classes.heroDivider}/>
                        <Typography className={classes.heroBody} component="div">
                            MODERNÉ POHREBNÍCTVO je webová aplikácia, ktorá pomáha modernizovať
                            pohrebné služby. Táto webová aplikácia slúži pohrebníctvam na kompletne zaznamenanie
                            a vybavenie pohrebu.
                            Tak, ako každé odvetvie prechádza modernizáciou rozhodli sme sa s našou firmou
                            MODERNÉ POHREBNÍCTVO priniesť túto modernizáciu aj do sveta pohrebných služieb.
                            Sme jediný na Slovensku kto takúto aplikáciu ponúka. Preto nás neváhajte kontaktovať
                            a zmodernizujte aj Vy Vašeš pohrebníctvo. Chcete vedieť{' '}
                            <Link to="/informacie" target="_blank" rel="noopener noreferrer">viac?</Link>
                        </Typography>

                        <div className={classes.heroContactBlock}>
                            <Typography className={classes.heroContactTitle} component="h3">
                                Kontakt
                            </Typography>
                            <Typography className={classes.heroContactBody} component="div">
                                V prípade záujmu alebo akýchkoľvek otázok nás neváhajte kontaktovať na tel. č.:{' '}
                                <span className={classes.contactStrong}>0907292958</span>
                                <br/>
                                Mailovou formou na:{' '}
                                <span className={classes.contactStrong}>modernepohrebnictvo@gmail.com</span>
                            </Typography>
                        </div>
                    </div>
                </Fade>
            </Grid>
        </Grid>
    );
}
